// // import React, { useState } from 'react';
// // import axios from 'axios';
// // import { API_PATH } from '../Constant/constants';
// // import useAuth from '../config/useAuth'; // adjust your path if needed

// // const DoctorSlotChecker = () => {
// //   const { user } = useAuth();
// // const doctorId = user?.id; // ✅ auto-fetch doctorId from logged-in user
// // console.log("x",user)
// //   const [date, setDate] = useState('');
// //   const [slots, setSlots] = useState([]);
// //   const [loading, setLoading] = useState(false);

// //   const handleCheckSlots = async (e) => {
// //     e.preventDefault();
// //     if (!doctorId || !date) return alert('Doctor ID or Date missing.');

// //     setLoading(true);
// //     const token = localStorage.getItem('authToken');

// //     try {
// //       const res = await axios.get(
// //         `${API_PATH}/appointments/slots/all`,
// //         {
// //           headers: { Authorization: `Bearer ${token}` },
// //           params: {
// //             doctorId,
// //             date,
// //           },
// //         }
// //       );
// //       setSlots(res.data);
// //     } catch (error) {
// //       console.error('Error fetching slots:', error);
// //       alert('❌ Failed to fetch slots');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   return (
// //     <div className="container mt-4">
// //       <h3>🩺 Check Your Available Appointment Slots</h3>

// //       <form className="row g-3 mt-3" onSubmit={handleCheckSlots}>
// //         <div className="col-md-3">
// //           <input
// //             type="date"
// //             className="form-control"
// //             value={date}
// //             onChange={(e) => setDate(e.target.value)}
// //             required
// //           />
// //         </div>
// //         <div className="col-md-2">
// //           <button type="submit" className="btn btn-primary w-100">Check</button>
// //         </div>
// //       </form>

// //       {loading && <p className="mt-4">Loading available slots...</p>}

// //       {slots.length > 0 && (
// //         <div className="mt-4">
// //           <h5>🗓️ Available Slots</h5>
// //           <table className="table table-bordered table-striped mt-2">
// //             <thead className="table-dark">
// //               <tr>
// //                 <th>Slot ID</th>
// //                 <th>Schedule ID</th>
// //                 <th>Appointment Date</th>
// //                 <th>Start Time</th>
// //                 <th>End Time</th>
// //                 <th>Status</th>
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {slots.map((slot) => (
// //                 <tr key={slot.slotId}>
// //                   <td>{slot.slotId}</td>
// //                   <td>{slot.scheduleId}</td>
// //                   <td>{slot.appointmentDate}</td>
// //                   <td>{slot.startTime}</td>
// //                   <td>{slot.endTime}</td>
// //                   <td>{slot.status}</td>
// //                 </tr>
// //               ))}
// //             </tbody>
// //           </table>
// //         </div>
// //       )}

// //       {!loading && slots.length === 0 && date && (
// //         <p className="mt-4 text-muted">No slots found for selected date.</p>
// //       )}
// //     </div>
// //   );
// // };

// // export default DoctorSlotChecker;

// import React, { useState } from 'react';
// import axios from 'axios';
// import { API_PATH } from '../Constant/constants';
// import useAuth from '../config/useAuth';
// import { FaCalendarAlt } from 'react-icons/fa';
// import { Spinner } from 'react-bootstrap';

// const DoctorSlotChecker = () => {
//   const { user } = useAuth();
//   const doctorId = user?.id;

//   const [date, setDate] = useState('');
//   const [slots, setSlots] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const handleCheckSlots = async (e) => {
//     e.preventDefault();
//     if (!doctorId || !date) return alert('Doctor ID or Date missing.');

//     setLoading(true);
//     const token = localStorage.getItem('authToken');

//     try {
//       const res = await axios.get(`${API_PATH}/appointments/slots/all`, {
//         headers: { Authorization: `Bearer ${token}` },
//         params: { doctorId, date },
//       });
//       setSlots(res.data);
//     } catch (error) {
//       console.error('Error fetching slots:', error);
//       alert('❌ Failed to fetch slots');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="container py-5">
//       <div className="bg-light p-4 rounded shadow">
//         <h3 className="text-primary mb-4">
//           <FaCalendarAlt className="me-2" /> Check Your Available Appointment Slots
//         </h3>

//         <form className="row g-3" onSubmit={handleCheckSlots}>
//           <div className="col-md-4">
//             <input
//               type="date"
//               className="form-control"
//               value={date}
//               onChange={(e) => setDate(e.target.value)}
//               required
//             />
//           </div>
//           <div className="col-md-2">
//             <button type="submit" className="btn btn-success w-100">
//               {loading ? <Spinner animation="border" size="sm" /> : 'Check'}
//             </button>
//           </div>
//         </form>

//         {loading && <p className="mt-4 text-muted">🔄 Fetching available slots...</p>}

//         {slots.length > 0 && (
//           <div className="mt-4">
//             <h5 className="text-success mb-3">🗓️ Available Slots</h5>
//             <div className="table-responsive">
//               <table className="table table-bordered table-hover">
//                 <thead className="table-success">
//                   <tr>
//                     <th>Slot ID</th>
//                     <th>Schedule ID</th>
//                     <th>Appointment Date</th>
//                     <th>Start Time</th>
//                     <th>End Time</th>
//                     <th>Status</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {slots.map((slot) => (
//                     <tr key={slot.slotId}>
//                       <td>{slot.slotId}</td>
//                       <td>{slot.scheduleId}</td>
//                       <td>{slot.appointmentDate}</td>
//                       <td>{slot.startTime}</td>
//                       <td>{slot.endTime}</td>
//                       <td>
//                         <span className={`badge bg-${slot.status === 'AVAILABLE' ? 'success' : 'secondary'}`}>
//                           {slot.status}
//                         </span>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}

//         {!loading && slots.length === 0 && date && (
//           <p className="mt-4 text-muted">⚠️ No slots found for selected date.</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default DoctorSlotChecker;

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_PATH } from '../Constant/constants';
import useAuth from '../config/useAuth';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { startOfMonth, endOfMonth, startOfWeek, endOfWeek, addDays, subMonths, addMonths, format } from 'date-fns';

const DoctorBookingListPage = () => {
  const { user, token } = useAuth();
  const [scheduleList, setScheduleList] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [newSlot, setNewSlot] = useState({ startTime: '', endTime: '', status: 'AVAILABLE' });
  const [slotAddVisible, setSlotAddVisible] = useState(false);
  const [filterDate, setFilterDate] = useState('');
  const [filteredSlots, setFilteredSlots] = useState([]);

  useEffect(() => {
    fetchBookingData();
  }, [user.id, token]);

  const fetchBookingData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_PATH}/doctors/${user.id}/schedule/list`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setScheduleList(response.data);
    } catch (error) {
      toast.error('Error fetching booking list');
    } finally {
      setLoading(false);
    }
  };

  const fetchFilteredSlots = async () => {
    if (!user?.id || !filterDate) return toast.error('Doctor ID or Date missing.');
    try {
      const res = await axios.get(`${API_PATH}/appointments/slots/all`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { doctorId: user.id, date: filterDate },
      });
      setFilteredSlots(res.data);
    } catch (error) {
      toast.error('Failed to fetch filtered slots');
    }
  };

  const generateCalendar = (date) => {
    const startDate = startOfWeek(startOfMonth(date));
    const endDate = endOfWeek(endOfMonth(date));
    let current = startDate;
    const calendar = [];

    while (current <= endDate) {
      const week = [];
      for (let i = 0; i < 7; i++) {
        week.push(current);
        current = addDays(current, 1);
      }
      calendar.push(week);
    }
    return calendar;
  };

  const calendar = generateCalendar(currentDate);

  const openModal = (schedule) => {
    setSelectedSchedule(schedule);
    setShowModal(true);
    setSlotAddVisible(false);
  };

  const closeModal = () => {
    setSelectedSchedule(null);
    setShowModal(false);
    setNewSlot({ startTime: '', endTime: '', status: 'AVAILABLE' });
  };

  const handleAddSlot = async () => {
    try {
      if (!selectedSchedule?.id) {
        toast.error("No schedule selected");
        return;
      }
      await axios.post(`${API_PATH}/doctors/schedule/${selectedSchedule.id}/slot`, newSlot, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Slot added successfully');
      closeModal();
      fetchBookingData();
    } catch (error) {
      toast.error('Failed to add slot');
    }
  };

  return (
    <div className="container py-4 bg-white shadow rounded my-4 w-100 mw-100">
      <h4 className="mb-4">Doctor Booking Calendar</h4>
      <ToastContainer />

      {/* Filter Section */}
      <div className="row mb-4">
        <div className="col-md-4">
          <input
            type="date"
            className="form-control"
            value={filterDate}
            onChange={(e) => setFilterDate(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <button className="btn btn-success w-100" onClick={fetchFilteredSlots}>Check Slots</button>
        </div>
      </div>

      {/* Calendar Grid */}
      <div className="d-flex fw-bold text-center mb-1">
        {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((d, i) => (
          <div key={i} className="flex-fill border py-2">{d}</div>
        ))}
      </div>

      <div className="d-flex flex-column gap-2">
        {calendar.map((week, weekIndex) => (
          <div className="d-flex" key={weekIndex}>
            {week.map((day, dayIndex) => {
              const dateStr = format(day, 'yyyy-MM-dd');
              const schedule = scheduleList.find(s => s.scheduleDate === dateStr);
              const total = schedule?.appointmentSlots?.length || 0;
              const empty = schedule?.appointmentSlots?.filter(s => s.status === 'AVAILABLE').length || 0;
              let color = 'bg-light';

              if (!schedule) color = 'bg-info';
              else if (total === 0) color = 'bg-danger';
              else if (empty === 0) color = 'bg-purple';
              else color = 'bg-success';

              return (
                <div
                  key={dayIndex}
                  onClick={() => schedule && openModal(schedule)}
                  className={`border rounded text-center flex-fill calendar-cell ${color}`}
                >
                  <div className="fw-bold">{format(day, 'd')}</div>
                  {schedule && (
                    <>
                      <div className="small">TA: {total}</div>
                      <div className="small">SE: {empty}</div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>

      {/* Prev/Next Buttons */}
      <div className="d-flex justify-content-between align-items-center mt-4">
        <button className="btn btn-outline-secondary" onClick={() => setCurrentDate(subMonths(currentDate, 1))}>{'<<'} Prev</button>
        <h5>{format(currentDate, 'MMMM yyyy')}</h5>
        <button className="btn btn-outline-secondary" onClick={() => setCurrentDate(addMonths(currentDate, 1))}>Next {'>>'}</button>
      </div>

      {/* Modal */}
      {showModal && selectedSchedule && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-scrollable" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Slots for {selectedSchedule.scheduleDate}</h5>
                <button type="button" className="btn-close" onClick={closeModal}></button>
              </div>
              <div className="modal-body">
                <ul className="list-group mb-3">
                  {selectedSchedule.appointmentSlots.map((slot, i) => (
                    <li className="list-group-item d-flex justify-content-between" key={i}>
                      <span>{slot.startTime} - {slot.endTime}</span>
                      <span className={`badge ${slot.status === 'AVAILABLE' ? 'bg-success' : 'bg-danger'}`}>{slot.status}</span>
                    </li>
                  ))}
                </ul>
                {slotAddVisible && (
                  <div>
                    <label>Start Time:</label>
                    <input
                      type="time"
                      className="form-control mb-2"
                      value={newSlot.startTime}
                      onChange={(e) => setNewSlot({ ...newSlot, startTime: e.target.value })}
                    />
                    <label>End Time:</label>
                    <input
                      type="time"
                      className="form-control mb-2"
                      value={newSlot.endTime}
                      onChange={(e) => setNewSlot({ ...newSlot, endTime: e.target.value })}
                    />
                  </div>
                )}
              </div>
              <div className="modal-footer">
                {!slotAddVisible ? (
                  <button className="btn btn-primary" onClick={() => setSlotAddVisible(true)}>+ Add Slot</button>
                ) : (
                  <>
                    <button className="btn btn-success" onClick={handleAddSlot}>Save</button>
                    <button className="btn btn-secondary" onClick={() => setSlotAddVisible(false)}>Cancel</button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Color Legend */}
      <div className="mt-4 d-flex gap-4">
        <div><span className="badge bg-success me-1">&nbsp;</span>Available</div>
        <div><span className="badge bg-purple me-1">&nbsp;</span>Few Slots</div>
        <div><span className="badge bg-danger me-1">&nbsp;</span>No Slot</div>
        <div><span className="badge bg-info me-1">&nbsp;</span>Not Available</div>
      </div>

      <style>{`
        .calendar-cell {
          min-width: 110px;
          height: 100px;
          margin: 3px;
          padding: 4px;
          cursor: pointer;
          color: #fff;
        }
        .bg-purple {
          background-color: #6f42c1 !important;
        }
      `}</style>
    </div>
  );
};

export default DoctorBookingListPage;


